export default {
  'en': 'English - Global',
  'es': 'Spanish',
  'de': 'German',
  'hi': 'Hindi'
};